<div class="data-filter">
    <label>
        <span [i18n]="labelKey"></span>
        <span *ngIf="required" class="required-asterisk">*</span>
        <span class="info-icon" *ngIf="tooltipKey" [tabIndex]="2" (focusout)="toggleTooltip()" (focusin)="toggleTooltip()">
            <i class="fa fa-info-circle"></i>
            <span class="tooltip-helper" *ngIf="showTooltip" [i18n]="tooltipKey"></span>
        </span>
    </label>
    <select class="form-control" [(ngModel)]="model" (change)="change()" [disabled]="disabled">
        <ng-container *ngIf="placeholderKey && !emptyOption">
            <option value="" disabled selected hidden [i18n]="placeholderKey"></option>
        </ng-container>
        <ng-container *ngIf="emptyOption">
            <option [ngValue]="null" selected [i18n]="emptyOptionKey"></option>
        </ng-container>
        <ng-container *ngIf="!useOptionLabel">
            <option *ngFor="let o of options" [ngValue]="o.value" [i18n]="o.labelKey ? o.labelKey : ''">{{o.labelKey}}</option>
        </ng-container>
        <ng-container *ngIf="useOptionLabel">
            <option *ngFor="let o of options" [ngValue]="o.value">{{o.label}}</option>
        </ng-container>
    </select>
    <span class="helper-message" *ngIf="helperKey" [i18n]="helperKey"></span>
</div>
